module.exports = __webpack_public_path__ + "static/media/136.d189daf5.jpg";